import { render, staticRenderFns } from "./ParcelImporterSection.vue?vue&type=template&id=04815c90&scoped=true&"
import script from "./ParcelImporterSection.vue?vue&type=script&lang=js&"
export * from "./ParcelImporterSection.vue?vue&type=script&lang=js&"
import style0 from "./ParcelImporterSection.vue?vue&type=style&index=0&id=04815c90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04815c90",
  null
  
)

export default component.exports